<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="dashboard"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid class="home-content rounded-lg">
      <v-tabs v-model="tabIndex">
        <v-tab v-for="item in items" :key="item.id">{{ item.tab }}</v-tab>
      </v-tabs>
    </v-container>
    <v-container fluid class="home-content rounded-lg">
      <v-row  justify="center">
        <v-tabs-items v-model="tabIndex" class="min-width">
          <v-tab-item active class="">
            <detail-comment></detail-comment>
          </v-tab-item>
          <v-tab-item>
            <add-comment></add-comment>
          </v-tab-item>
        </v-tabs-items>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DetailComment from "@/components/comment/detail_comment";
import AddComment from "@/components/comment/list_child_comment";
export default {
  components: {
    AddComment,
    DetailComment
  },
  data() {
    return {
      tabIndex: 0,
      items: [
        {id: 0, tab: "Chi tiết"},
        // { id: 1, tab: "Countdown" },
        {id: 1, tab: "Danh sách bình luận trả lời"},
      ],
      active: [
        {id: 1, name: 'KHÁCH HÀNG'},
        {id: 2, name: 'QUẢN TRỊ VIÊN'},
      ],
      active_status: [
        {id:1, name:'CHƯA KÍCH HOẠT'},
        {id:2, name:'ĐÃ KÍCH HOẠT'},
        {id:3, name:'KHÔNG KÍCH HOẠT'},
      ],
      page: "Chi tiết",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
            text: "Bình luận đánh giá",
          disabled: true,
        },
        {
          text: "Chi tiết",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
    ]),
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style lang="scss">
.home-content {
  background: #ffffff !important;
}
.min-width {
  min-width: 90% !important;
}
</style>
